import Cookie from 'js-cookie';

export const detectCountry = () => Cookie.get('GEO_COUNTRY');
